
export const isMobile = () => {
	return /Mobi|Android|iPhone/i.test(navigator.userAgent)
}


export const widthAndHeigth = () => {

	return {
		width: window.innerWidth,
		height: window.innerHeight
	}
}